import { request } from '@meta-vue/util'
import { avayaSocketUserWhiteList } from '@/util/const'

const defaultActiveCallUserWhiteList = [1018737, 1007367]

const defaultDomainSwitchWhiteList = [9497]
/**
 * 需求背景：涉及avaya sdk的改动，比较慎重，因此从后端调用相关功能的灰度用户名单列表，来进行功能灰度
 *
 * reconnectUserWhiteList：socket重连功能灰度名单 已废弃
 * setActiveCallUserWhiteList：心跳超时修复灰度名单 已废弃
 * domainSwitchWhiteList: avaya cti链接替换白名单
 * 注该白名单已废弃
 */
export default async function getAvayaUserWhiteList() {
  let reconnectUserWhiteList = (localStorage.__avaya_socket_whitelist = avayaSocketUserWhiteList)
  let setActiveCallUserWhiteList = (localStorage.__avaya_active_call_whitelist = defaultActiveCallUserWhiteList)
  let domainSwitchWhiteList = (localStorage.__avaya_domain_switch_whitelist = defaultDomainSwitchWhiteList)
  // try {
  //   const res = (await request('/callcenter-app/config/queryAvayaFunctionGrayUserIds')) || {}
  //   reconnectUserWhiteList = res.reconnectUserWhiteList || avayaSocketUserWhiteList
  //   setActiveCallUserWhiteList = res.setActiveCallUserWhiteList || defaultActiveCallUserWhiteList
  //   domainSwitchWhiteList = res.domainSwitchWhiteList || defaultDomainSwitchWhiteList
  // } catch (error) {
  //   console.log('fetch avaya white list error', error)
  // }

  localStorage.__avaya_socket_whitelist = JSON.stringify(reconnectUserWhiteList)
  localStorage.__avaya_active_call_whitelist = JSON.stringify(setActiveCallUserWhiteList)
  localStorage.__avaya_domain_switch_whitelist = JSON.stringify(domainSwitchWhiteList)
}
